import gql from 'graphql-tag';
import PublicUserProfile from './public_user_profile';

export default gql`
  fragment ContentReactions on ContentReactions {
    reaction_count {
      total
    }
    user_reactions
    reaction_user_details {
      ...PublicUserProfile
    }
  }
  ${PublicUserProfile}
`;
